export var ConfirmationType;

(function (ConfirmationType) {
  ConfirmationType["SMS"] = "SMS";
  ConfirmationType["EMAIL"] = "EMAIL";
  ConfirmationType["PUSH"] = "PUSH";
  ConfirmationType["TOTP"] = "TOTP";
})(ConfirmationType || (ConfirmationType = {}));